// extracted by mini-css-extract-plugin
module.exports = {"errorBackground":"rKwUr5jam-s9VS-QqCH-E","errorContainer":"_17uD8dnILLSkzJCE6sfRId"};